import 'react-phone-number-input/style.css';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { CountryDropdown } from 'react-country-region-selector';
import PhoneInput, { formatPhoneNumberIntl } from 'react-phone-number-input';
// import OtpInput from 'react-otp-input';
import { makeStyles } from '@material-ui/core/styles';
// import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { Button } from '@material-ui/core';
// import MenuItem from '@material-ui/core/MenuItem';
//import FormHelperText from '@material-ui/core/FormHelperText';
// import FormControl from '@material-ui/core/FormControl';
// import Select from '@material-ui/core/Select';
import 'react-phone-number-input/style.css';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  starting_div: {
    paddingRight: '16px',
    paddingLeft: '16px',
    paddingBottom: '48px',
  },
  grid1: {
    marginTop: '8px',
  },
  griditems: {
    paddingRight: '15px',
    paddingLeft: '15px',
  },
  gridnew: {
    paddingRight: '15px',
    paddingLeft: '15px',
    marginTop: '8px',
  },
  externalInputs: {
    width: '100%',
    backgroundColor: 'white',
    border: 'grey 1px solid',
    borderRadius: '5px',
    padding: '5px 2px',
  },
  optionaldiv: {
    marginTop: '48px',
    textAlign: 'center',
  },
});

const PersonalProfileForm = ({ data, token }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [officeName, setOfficeName] = useState('');
  const [flat, setFlat] = useState('');
  const [village, setVillage] = useState('');
  const [street, setStreet] = useState('');
  const [area, setArea] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [country, setCountry] = useState('');
  const [adharNumber, setAdharNumber] = useState('');
  const [DOB, setDOB] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [zipCode, setZipCode] = useState('');
  const [phone, setPhone] = useState();

  const [editProfile, setEditProfile] = useState(false);

  useEffect(() => {
    if (data) {
      const parsedAddressObj = JSON.parse(data.personal_address);
      setFirstName(data.name.split(' ')[0]);
      setLastName(data.name.split(' ')[1] ? data.name.split(' ')[1] : '');
      setEmail(data.email);
      setZipCode(data.zipCode);
      setAdharNumber(data.adharNumber);

      setOfficeName(parsedAddressObj.officeName);
      setFlat(parsedAddressObj.flat);
      setVillage(parsedAddressObj.village);
      setStreet(parsedAddressObj.street);
      setArea(parsedAddressObj.area);
      setCity(parsedAddressObj.city);
      setState(parsedAddressObj.state);
      setCountry(parsedAddressObj.country);

      setDOB(data.DOB);
      setCountryCode(data.country_code);
      setPhone(data.phone_num);
    }
  }, [data]);

  const handleSubmit = () => {
    const address = {
      officeName,
      flat,
      village,
      street,
      area,
      city,
      state,
      country,
    };

    const data = {
      name: firstName + ' ' + lastName,
      email,
      phone: phone ? formatPhoneNumberIntl(phone) : '',
      country_code: formatPhoneNumberIntl(phone).split(' ')[0],
      personal_address: JSON.stringify(address),
      DOB,
      adharNumber,
      zipCode,
    };

    axios
      .post(
        `https://account-testing-be.herokuapp.com/users/personalProfile/update`,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
            token: token,
          },
        }
      )
      .then((res) => {
        window.alert(res.data.message);
        window.location.reload();
        if (res.data.status === 400) {
          if (res.data.message) {
            window.alert(res.data.message);
            window.location.reload();
          }
        }
      })
      .catch((err) => {
        window.alert('some error occured please check console');
        console.log(err);
      });
  };

  return (
    <div className={classes.starting_div}>
      <div>
        <h4 style={{ textAlign: 'left' }}>{t('profile-PPF-Header')}</h4>
      </div>
      {/* Grid 1 */}
      <Grid container spacing={2} className={classes.grid1}>
        <Grid items md={6} sm={12} className={classes.griditems}>
          {t('profile-PPF-FirstName')}
          <TextField
            type="text"
            fullWidth
            required
            label={t('profile-PPF-FirstName')}
            variant="outlined"
            placeholder={t('profile-PPF-FirstName')}
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            disabled={!editProfile}
          />
        </Grid>
        <Grid items md={6} sm={12} className={classes.griditems}>
          {t('profile-PPF-LastName')}
          <TextField
            type="text"
            fullWidth
            required
            label={t('profile-PPF-LastName')}
            variant="outlined"
            placeholder={t('profile-PPF-LastName')}
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            disabled={!editProfile}
          />
        </Grid>
        {/* Textfield from emailid */}
        <Grid items md={12} className={classes.gridnew}>
          Email ID
          <TextField
            type="email"
            fullWidth
            required
            label={t('profile-PPF-Email')}
            variant="outlined"
            placeholder={t('profile-PPF-Email')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={!editProfile}
          />
        </Grid>
        {/* phoneinput */}
        <Grid items md={12} className={classes.gridnew}>
          Phone Number
          <PhoneInput
            className={classes.externalInputs}
            placeholder={t('profile-PPF-Phno')}
            value={phone}
            onChange={setPhone}
            defaultCountry="IN"
            countryOptionsOrder={['IN', '🌐', 'AU', 'SG', 'AE', 'GB', 'US']}
            disabled={!editProfile}
          />
        </Grid>
        {/* dob */}
        <Grid items md={12} className={classes.gridnew}>
          {t('profile-PPF-DOB')}
          <TextField
            type="date"
            fullWidth
            required
            variant="outlined"
            placeholder={t('profile-PPF-DOB')}
            value={DOB}
            onChange={(e) => setDOB(e.target.value)}
            disabled={!editProfile}
          />
        </Grid>

        <Grid items md={12} className={classes.gridnew}>
          {t('profile-PPF-NOO')}
          <TextField
            type="text"
            fullWidth
            required
            variant="outlined"
            placeholder={t('profile-PPF-NOO')}
            value={officeName}
            onChange={(e) => setOfficeName(e.target.value)}
            disabled={!editProfile}
          />
        </Grid>
        {/* Flat/Room/Door/Block No */}
        <Grid items md={12} className={classes.gridnew}>
          {t('profile-PPF-FRDBN')}
          <TextField
            type="text"
            fullWidth
            required
            variant="outlined"
            placeholder={t('profile-PPF-FRDBN')}
            value={flat}
            onChange={(e) => setFlat(e.target.value)}
            disabled={!editProfile}
          />
        </Grid>
        {/* Name of Permisis/Building/Village */}
        <Grid items md={12} className={classes.gridnew}>
          {t('profile-PPF-NPBV')}
          <TextField
            type="text"
            fullWidth
            required
            variant="outlined"
            placeholder={t('profile-PPF-NPBV')}
            value={village}
            onChange={(e) => setVillage(e.target.value)}
            disabled={!editProfile}
          />
        </Grid>
        {/* Road/Street/Lane/Post office */}
        <Grid items md={12} className={classes.gridnew}>
          {t('profile-PPF-RSLPO')}
          <TextField
            type="text"
            fullWidth
            required
            variant="outlined"
            placeholder={t('profile-PPF-RSLPO')}
            value={street}
            onChange={(e) => setStreet(e.target.value)}
            disabled={!editProfile}
          />
        </Grid>
        {/* Area/Locality/Taluka/Sub-division */}
        <Grid items md={12} className={classes.gridnew}>
          {t('profile-PPF-ALTSD')}
          <TextField
            type="text"
            fullWidth
            required
            variant="outlined"
            placeholder={t('profile-PPF-ALTSD')}
            value={area}
            onChange={(e) => setArea(e.target.value)}
            disabled={!editProfile}
          />
        </Grid>
        {/* Town/City/District */}
        <Grid items md={12} className={classes.gridnew}>
          {t('profile-PPF-TCD')}
          <TextField
            type="text"
            fullWidth
            required
            variant="outlined"
            placeholder={t('profile-PPF-TCD')}
            value={city}
            onChange={(e) => setCity(e.target.value)}
            disabled={!editProfile}
          />
        </Grid>
        {/* State/Union Territory */}
        <Grid items md={12} className={classes.gridnew}>
          {t('profile-PPF-SUT')}
          <TextField
            type="text"
            fullWidth
            required
            variant="outlined"
            placeholder={t('profile-PPF-SUT')}
            value={state}
            onChange={(e) => setState(e.target.value)}
            disabled={!editProfile}
          />
        </Grid>
        {/* zip code */}
        <Grid items md={12} className={classes.gridnew}>
          {t('profile-PPF-Zipcode')}
          <TextField
            type="text"
            fullWidth
            required
            variant="outlined"
            placeholder={t('profile-PPF-Zipcode')}
            value={zipCode}
            onChange={(e) => setZipCode(e.target.value)}
            disabled={!editProfile}
          />
        </Grid>

        {/* country select */}
        <Grid items md={12} className={classes.gridnew}>
          {t('profile-PPF-Country')}
          <CountryDropdown
            className={classes.externalInputs}
            value={country}
            onChange={(val) => setCountry(val)}
            disabled={!editProfile}
          />
        </Grid>
        {/* Aadhar Number */}
        <Grid items md={12} className={classes.gridnew}>
          {t('profile-PPF-Aadhar')}
          <TextField
            type="text"
            fullWidth
            required
            variant="outlined"
            placeholder={t('profile-PPF-Aadhar')}
            value={adharNumber}
            onChange={(e) => setAdharNumber(e.target.value)}
            disabled={!editProfile}
          />
        </Grid>
      </Grid>
      {/* optional div */}
      <div className={classes.optionaldiv}>
        {editProfile ? (
          <>
            <Button
              variant="contained"
              color="primary"
              className="profile-button"
              type="button"
              onClick={handleSubmit}
            >
              {t('profile-PPF-Update')}
            </Button>
            <Button
              variant="contained"
              color="secondary"
              className="profile-button"
              style={{ marginLeft: '32px' }}
              type="button"
              onClick={() => setEditProfile(false)}
            >
              {t('profile-PPF-cancel')}
            </Button>
          </>
        ) : (
          <Button
            variant="contained"
            color="primary"
            className="profile-button"
            type="button"
            onClick={() => setEditProfile(true)}
          >
            {t('profile-PPF-Edit')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default PersonalProfileForm;
